import React, { useState } from "react";
import Input from "../../../../../../../../../../../../components/Input";

export default function CustomAppDescriptions({
                                                  app, messages, update
                                              }) {

    const [short, setShort] = useState(app.short_description);
    const [full, setFull] = useState(app.description);

    return (
        <>
            {/*<AddPlaceholder*/}
            {/*    reveal={!!app.short_description?.length}*/}
            {/*    title='Add short description'*/}
            {/*    messages={messages}*/}
            {/*    container='blah-blah-blah'*/}
            {/*    target='add-button'*/}
            {/*    margin='0 5px 5px 0'*/}
            {/*    small*/}
            {/*>*/}
                <Input
                    type='textarea'
                    name='short_description'
                    placeholder='Stack short description'
                    iconLeft='fas fa-cube'
                    value={short}
                    onChange={e => {
                        const {value} = e.target;
                        update({short_description: value});
                        setShort(value);
                    }}
                />
            {/*</AddPlaceholder>*/}
            {/*<AddPlaceholder*/}
            {/*    reveal={!!app.description?.length}*/}
            {/*    title='Add full description'*/}
            {/*    messages={messages}*/}
            {/*    container='blah-blah-blah'*/}
            {/*    target='add-button'*/}
            {/*    margin='0 5px 5px 0'*/}
            {/*    small*/}
            {/*>*/}
                <Input
                    type='textarea'
                    name='description'
                    placeholder='Stack full description'
                    iconLeft='fas fa-cube'
                    value={full}
                    onChange={e => {
                        const {value} = e.target;
                        update({description: value});
                        setFull(value);
                    }}
                />
            {/*</AddPlaceholder>*/}
        </>
    )
}